import { useTranslation } from 'react-i18next'
import type { PostUserLoginRequestBody } from '@brilltek42/template-types'
import { Button, Checkbox, Form, Input } from 'antd'

interface UserLoginFormProps {
  onSubmit: (formData: PostUserLoginRequestBody) => void
}

export const UserLoginForm = ({ onSubmit }: UserLoginFormProps) => {
  const { t } = useTranslation()

  return (
    <Form
      name="basic"
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 16 }}
      initialValues={{ remember: true }}
      onFinish={onSubmit}
    >
      <Form.Item
        label={t('Username')}
        name="email"
        rules={[
          { required: true, message: t('isRequired', { name: t('Email') }) },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label={t('Password')}
        name="password"
        rules={[
          { required: true, message: t('isRequired', { name: t('Password') }) },
        ]}
      >
        <Input.Password />
      </Form.Item>

      <Form.Item
        name="rememberMe"
        valuePropName="checked"
        wrapperCol={{ offset: 8, span: 16 }}
      >
        <Checkbox>{t('RememberMe')}</Checkbox>
      </Form.Item>

      <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
        <Button type="primary" htmlType="submit">
          {t('Submit')}
        </Button>
      </Form.Item>
    </Form>
  )
}
